export default __webpack_public_path__ + "static/media/5dc9d6bc47a849d5de67e3953415895c.svg";